import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/home-blocks-hub")({
  component: lazyRouteComponent(() => import("./-pages/admin.home-blocks-hub")),
  head: () => ({
    meta: [
      { title: "بلوكات الهوم — مركز واحد" },
      { name: "description", content: "إدارة كلّ بلوكات الصفحة الرئيسيّة من شاشة واحدة." },
      { name: "robots", content: "noindex" },
    ],
  }),
});
